import { useEffect, useState } from "react";

export default function LogsPanel({
    logs,
}: {
    logs: any,
}) {

    const [output, setOutput] = useState('');

    useEffect(() => {
        if (logs.return_value && typeof logs.return_value === 'string') {
            setOutput(logs.return_value)
        } else if (logs.result) {
            // let errorOutput = '';

            const result = logs.result;
            // if (result.traceback) {
            //     errorOutput += result.traceback;
            //     console.log(result.traceback)
            // }

            if (result.docker_stderr_logs && typeof result.docker_stderr_logs === 'string') {
                setOutput(result.docker_stderr_logs)
            }

            // setOutput(errorOutput);
        }
    }, [logs]);



    return (
        <div className="w-full max-h-[450px] overflow-y-auto p-2 bg-secondary bg-opacity-[0.5] border border-primary rounded ">
            <pre className="max-w-content whitespace-pre-wrap text-[10px] text-default">
                <code>{output}</code>
            </pre>
        </div>
    )
}